export const PALETTES = {
  chrome: {
    bg: "conic-gradient(from 210deg at 40% 40%, #cfe3ee, #e3d8f0, #f3dcd8, #f8e3cf, #d5e8f0, #cfe3ee)",
    number: "#171514",
    caption: "Chrome Study",
  },
  noir: {
    bg: "linear-gradient(160deg, #1c1917 0%, #2a2521 55%, #171514 100%)",
    number: "transparent",
    numberChrome: true,
    caption: "Noir Study",
  },
  blush: { bg: "linear-gradient(150deg, #f9ecec 0%, #f5e3e1 60%, #efd6d2 100%)", number: "#171514", caption: "Blush Study" },
  lavender: { bg: "linear-gradient(150deg, #f1ebf7 0%, #e9e2f2 55%, #dccfee 100%)", number: "#171514", caption: "Lavender Study" },
  ice: { bg: "linear-gradient(150deg, #eef6fa 0%, #dceaf1 55%, #c9dde8 100%)", number: "#171514", caption: "Ice Study" },
  coral: { bg: "linear-gradient(150deg, #fbf0e6 0%, #f6dac9 60%, #f0cbb2 100%)", number: "#171514", caption: "Coral Study" },
  pearl: {
    bg: "radial-gradient(circle at 30% 25%, #ffffff 0%, #f4f0ec 45%, #e9e2f2 100%)",
    number: "#171514",
    caption: "Pearl Study",
  },
  ink: {
    bg: "linear-gradient(200deg, #f6f3f0 0%, #ece7e1 50%, #ddd5cc 100%)",
    number: "#171514",
    caption: "Ink Study",
  },
  spectrum: {
    bg: "radial-gradient(58% 48% at 84% 8%, rgba(70,130,255,0.6) 0%, rgba(205,70,225,0.5) 34%, rgba(255,130,50,0.38) 58%, transparent 78%), linear-gradient(160deg, #16130f 0%, #1d1814 60%, #16130f 100%)",
    number: "transparent",
    numberChrome: true,
    caption: "Flagship",
  },
  midnight: {
    bg: "linear-gradient(155deg, #101318 0%, #171b26 55%, #0f1116 100%)",
    number: "transparent",
    numberChrome: true,
    caption: "Midnight Study",
  },
  white: {
    bg: "#ffffff",
    number: "#171514",
    caption: "White Study",
  },
  black: {
    bg: "#000000",
    number: "transparent",
    numberChrome: true,
    caption: "Black Study",
  },
  learnblue: {
    bg: "linear-gradient(120deg, #26CFCC 0%, #1F7CA8 45%, #1A297F 100%)",
    number: "transparent",
    numberChrome: true,
    caption: "Learnprint Blue",
  },
};
